// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TimerTips_TheComp__fqcWK"};